import { render } from "./AssistantRecruitTitle.vue?vue&type=template&id=47163bc8&scoped=true"
import script from "./AssistantRecruitTitle.vue?vue&type=script&lang=js"
export * from "./AssistantRecruitTitle.vue?vue&type=script&lang=js"

import "./AssistantRecruitTitle.vue?vue&type=style&index=0&id=47163bc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47163bc8"]])

export default __exports__